var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "public-head" } }, [
    _vm.topImgUrl
      ? _c(
          "header",
          {
            staticClass: "top_heads",
            style: { backgroundImage: "url(" + _vm.topImgUrl + ")" }
          },
          [
            _vm.isGteatChefbrowser
              ? [
                  _c("router-link", {
                    staticClass: "back fl",
                    attrs: { to: "/index2019?goback=1" }
                  }),
                  _c("span", {
                    staticClass: "share fr",
                    on: { click: _vm.shareLinkFn }
                  })
                ]
              : _vm._e(),
            _vm.desc
              ? [
                  _c(
                    "div",
                    { staticClass: "explain", on: { touchstart: _vm.show } },
                    [
                      _c("span", { staticClass: "explain-log " }),
                      _c("span", { staticClass: "explain-title" }, [
                        _vm._v("榜单说明 ")
                      ])
                    ]
                  ),
                  _c("div", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.infosShow,
                        expression: "infosShow"
                      }
                    ],
                    staticClass: "infos",
                    domProps: { innerHTML: _vm._s(_vm.desc) },
                    on: {
                      click: function($event) {
                        _vm.infosShow = false
                      }
                    }
                  })
                ]
              : _vm._e()
          ],
          2
        )
      : _c(
          "header",
          { staticClass: "noHeader" },
          [
            _vm.isGteatChefbrowser
              ? [
                  _c("span", {
                    staticClass: "share fr",
                    on: { click: _vm.shareLinkFn }
                  })
                ]
              : _vm._e()
          ],
          2
        ),
    _c("input", {
      attrs: {
        id: "shareImg",
        type: "hidden",
        value:
          "https://img.mingchu.co/ueditor/php/upload/image/20200119/1579429167875371.jpg"
      }
    }),
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.shareInfo.shareLink,
          expression: "shareInfo.shareLink"
        }
      ],
      attrs: { id: "shareLink", type: "hidden" },
      domProps: { value: _vm.shareInfo.shareLink },
      on: {
        input: function($event) {
          if ($event.target.composing) {
            return
          }
          _vm.$set(_vm.shareInfo, "shareLink", $event.target.value)
        }
      }
    }),
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.shareInfo.shareTitle,
          expression: "shareInfo.shareTitle"
        }
      ],
      attrs: { id: "shareTitle", type: "hidden" },
      domProps: { value: _vm.shareInfo.shareTitle },
      on: {
        input: function($event) {
          if ($event.target.composing) {
            return
          }
          _vm.$set(_vm.shareInfo, "shareTitle", $event.target.value)
        }
      }
    }),
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.shareInfo.shareDesc,
          expression: "shareInfo.shareDesc"
        }
      ],
      attrs: { id: "shareDesc", type: "hidden" },
      domProps: { value: _vm.shareInfo.shareDesc },
      on: {
        input: function($event) {
          if ($event.target.composing) {
            return
          }
          _vm.$set(_vm.shareInfo, "shareDesc", $event.target.value)
        }
      }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }